import { Table as BootstrapTable } from 'react-bootstrap';
import styled from 'styled-components';

export const BubbleTable = styled(BootstrapTable)`
  --radius: 5px;
  --color: #dedede;

  border-collapse: separate;
  td,
  th,
  tr,
  thead,
  tbody {
    border: none;
  }
  thead {
    overflow: hidden;
    border-radius: 5px;
  }

  thead th {
    border-right: 1px solid #eee;
    padding-top: 1em;
    font-weight: normal;
    color: black;
    font-weight: 500;
    padding-bottom: 1em;

    &:last-of-type {
      border-right: none;
    }
  }

  tr {
    overflow: hidden;
    border: 1px solid gray;
    border-radius: 5px;
    box-shadow: 0 0 2px inset rgba(0, 0, 0, 0.05);
    transition: 300ms linear all;
    &:hover {
      background: #fafafa;
    }
    td,
    th {
      color: #282828;
      margin: 0;
      border-top: 1px solid var(--color);
      border-bottom: 1px solid var(--color);
    }

    td:first-of-type,
    th:first-of-type {
      overflow: hidden;
      border-radius: var(--radius) 0 0 var(--radius);
      border-left: 1px solid var(--color);
    }

    td:last-of-type,
    th:last-of-type {
      border-radius: 0 var(--radius) var(--radius) 0;
      border-right: 1px solid var(--color);
    }
  }
`;
